const deliveryMethods = [
	{
		value: '',
		label: 'Tümü',
	},
	{
		value: '1',
		label: 'Mağazadan Teslimat',
	},
	{
		value: '2',
		label: 'Adrese Teslimat',
	},
	{
		value: '3',
		label: 'Başka Mağazadan Teslimat',
	},
]

export default deliveryMethods;